import { createSlice } from "@reduxjs/toolkit";

export const transferSlice = createSlice({
    name: 'transfer',
    initialState: {
        transferFrom: "fromBlank",
        transferTo: "toBlank",
        transferAmount: 0.00,
        fromError: false,
        toError: false,
        validAmountCheck: true,
        confirming: false,
        transferStatus: ''
    },
    reducers: {
        setTransferFrom: (state, action) => {
            return {
                ...state,
                transferFrom: action.payload,
                fromError: action.payload === "fromBlank" || action.payload === state.transferTo 
            }
        },
        setTransferTo: (state, action) => {
            return {
                ...state,
                transferTo: action.payload,
                toError: action.payload === "toBlank" || action.payload === state.transferFrom
            }
        },
        setTransferAmount: (state, action) => {
            return {
                ...state,
                transferAmount: action.payload.transferAmount,
                validAmountCheck: action.payload.validAmountCheck
            }
        },
        resetTransferForm: (state) => {
            return {
                ...state,
                transferFrom: "fromBlank",
                transferTo: "toBlank",
                transferAmount: 0.00,
                fromError: false,
                toError: false,
                validAmountCheck: true
            }
        },
        setTransferConfirming: (state, action) => {
            return {
                ...state,
                confirming: action.payload
            }
        },
        changeTransferFormStatus: (state, action) => {
            return {
                ...state,
                transferStatus: action.payload
            }
        }
    }
})

export const selectTransferFrom = (state) => state.transfer.transferFrom;
export const selectTransferTo = (state) => state.transfer.transferTo;
export const selectTransferAmount = (state) => state.transfer.transferAmount;
export const selectFromError = (state) => state.transfer.fromError;
export const selectToError = (state) => state.transfer.toError;
export const selectValidAmountCheck = (state) => state.transfer.validAmountCheck;
export const transferIsConfirming = (state) => state.transfer.confirming;
export const selectTransferFormStatus = (state) => state.transfer.transferStatus;

export const { setTransferFrom, setTransferTo, setTransferAmount, resetTransferForm, setTransferConfirming, changeTransferFormStatus } = transferSlice.actions;

export default transferSlice.reducer;